// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Box_wrap__17EaV","basic":"Box_basic__2TcAe","gutterBottom":"Box_gutterBottom__3fQaR","notPadding":"Box_notPadding__s6sbv"};